import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
  name: 'datetime',
})
export class DatetimePipe implements PipeTransform {
  transform(value: string | number, timezone?: string, displaySeconds = true): string {
    return moment(value)
      .tz(timezone || moment.tz.guess())
      .format(`MMM DD, yyyy HH:mm${displaySeconds ? ':ss' : ''} z`);
  }
}
